import { useLearnerNotificationContext } from "../Context/LearnerNotification.context"

const useLearnerNotifications = () => useLearnerNotificationContext()

export default useLearnerNotifications
